// 表示設定コンフィグ
const DATA_TABLE = {
  ITEMS_PER_PAGE_DEFAULT: 100
}
const SHORTCUT_MAX_LENGTH = 5

export default {
  DATA_TABLE,
  SHORTCUT_MAX_LENGTH
}
